import { FormHelperText, SxProps } from '@mui/material';
import { ReactNode } from 'react';

const validationErrorStyle: SxProps = {
    marginLeft: 0,
    fontWeight: 700,
    paddingTop: '16px',
};

type Props = {
    children: ReactNode;
};

const ValidationErrorMessage = ({ children }: Props) => {
    return (
        <FormHelperText error={true} sx={validationErrorStyle}>
            {children}
        </FormHelperText>
    );
};

export default ValidationErrorMessage;
